import {Anchor} from 'grommet'
import styled from 'styled-components'

const ExternalLink = styled(Anchor).attrs({target: '_blank'})``

export default ExternalLink
